import React from 'react';
import SelectBox from '../../components/formInputs/SelectBox';
import NoData from '../../components/NoData';
import Spinner from '../../components/Spinner/Spinner';
import formStyle from './orders.module.css';

const OrderData = ({
	showFilter,
	orderList,
	onChangeHandler,
	setModalSummaryState,
	setProductSummaryList,
	statusError,
	setStatus,
	statusList
}) => {
	return (
		<div className='tableContainer tableContainer_order' style={{ height: showFilter ? '63vh' : '65vh' }}>
			<table className='table'>
				<thead>
					<tr>
						<th>#</th>
						<th>Amount</th>
						<th>Other Amount</th>
						<th>Total Amount</th>
						<th>OrderBy</th>
						<th>Status</th>
						<th>Product Summary</th>
						<th />
					</tr>
				</thead>
				<tbody>
					{orderList.loading ? (
						<tr>
							<td colSpan='7' style={{ textAlign: 'center' }}>
								<Spinner />
							</td>
						</tr>
					) : orderList &&
						orderList.categories &&
						orderList.categories.status &&
						orderList.categories.data.result &&
						orderList.categories.data.result.length > 0 ? (
						orderList.categories.data.result.map((d, index) => (
							<tr key={index}>
								<td>{d.orderId}</td>
								<td>$ {d.amount}</td>
								<td>$ {d.otherAmount}</td>
								<td>$ {d.totalAmount}</td>
								<td>
									{d.orderBy.name}
									{' (Phone: xxxx-xxx-' + d.orderBy.phone.substring(d.orderBy.phone.length - 4) + ')'}
								</td>
								<td>
									{/* <SelectBox
										value={d.orderStatus}
										onChange={(e) => {
											d.orderStatus = e.target.value;
											setStatus(e.target.value);
											onChangeHandler(d, e.target.value);
										}}
										errorMessage={statusError}>
										{statusList &&
											statusList.map((status) => (
												<option value={status.value} key={status._id}>
													{status.name}
												</option>
											))}
									</SelectBox> */}
									<select
										name='status'
										id='status'
										className={formStyle.selectBox}
										value={d.orderStatus}
										onChange={(e) => {
											d.orderStatus = e.target.value;
											setStatus(e.target.value);
											onChangeHandler(d, e.target.value);
										}}>
										{statusList &&
											statusList.map((status) => (
												<option value={status.value} key={status._id}>
													{status.name}
												</option>
											))}
									</select>
								</td>
								<td>
									<button
										className={formStyle.signDataAddBtn}
										onClick={() => {
											setProductSummaryList(d);
											setModalSummaryState(true);
										}}>
										<svg className={formStyle.signDataAddBtnIcon}>
											<use xlinkHref={`/assets/sprite.svg#icon-document`} />
										</svg>
										Order Details
									</button>
								</td>
							</tr>
						))
					) : (
						<tr>
							<td colSpan='7' style={{ textAlign: 'center' }}>
								<NoData title='No Data Found!' subTitle='We could not find any order.' height='40vh' />
							</td>
						</tr>
					)}
				</tbody>
			</table>
		</div>
	);
};

export default OrderData;
